import React from 'react';
import styles from './HeaderFeatures.scss'
import {useSliderHook} from "../../../common/hooks/useSliderHook";
import Slider from "react-slick";
import {isInViewPortHook} from "../../../common/hooks/isInViewPortHook";
import {isMobileHook} from "../../../common/hooks/isMobileHook";

import icon1 from "./img/shbg-partners-b-advantages-01.svg";
import icon2 from "./img/shbg-partners-b-advantages-02.svg";
import icon3 from "./img/shbg-partners-b-advantages-03.svg";

const HeaderFeatures = props => {


	const {
		sliderRef,
		sliderInitialized,
		animationComplete,
		setAnimationComplete,
		settings
	} = useSliderHook(
		'js-header-features',
		'js-header-features-container',
		500);

	const isMobile = isMobileHook(500);

	const getPosts = () => [
		<div key={'feature_01'} className={styles.iconContainer}>
			<div className={styles.icon}>
				<img src={icon1} alt={'Свържете клиентите с клиентския профил'}/>
				<span>Специално подбрани <br/> професионалисти</span>
			</div>
		</div>,
		<div key={'feature_02'} className={styles.iconContainer}>
			<div className={styles.icon}>
				<img src={icon2} alt={'Получавайте комисион за всяко плащане от клиент'}/>
				<span>Избор според вашите <br/> конкретни нужди</span>
			</div>
		</div>,
		<div key={'feature_03'} className={styles.iconContainer}>
			<div className={styles.icon}>
				<img src={icon3} alt={'Получете завършено техническо решение'}/>
				<span>Надежден партньор за <br/> вашия проект</span>
			</div>
		</div>
	]

	const getSlider = () => {
		return (
			<Slider {...settings} ref={sliderRef}>
				{getPosts()}
			</Slider>
		)
	};

	const isInViewPort = isInViewPortHook('js-header-features', false);
	if (sliderInitialized && isMobile && sliderRef && !animationComplete) {
		sliderRef.current.slickGoTo(3, true);
		if (isInViewPort) {
			setTimeout(() => {
				setAnimationComplete(true);
				sliderRef.current.slickGoTo(0);
			}, 2000)
		}
	}

	return (
		<div id="js-header-features-container" className={styles.iconsContainerOuter}>
			<div id={"js-header-features"} className={styles.container}>
				{isMobile ? getSlider() : getPosts()}
			</div>
		</div>
	);
};

HeaderFeatures.propTypes = {};

export default HeaderFeatures;